import { useGetDriverByIdQuery } from '../services';
import { DriverApi } from '../models';

type UseDriverProps = {
    driverId: string;
};

const useDriver = ({ driverId }: UseDriverProps) => {
    const { data, isLoading, error } = useGetDriverByIdQuery({
        id: driverId,
    });

    return {
        driver: data ?? ({} as DriverApi),
        isLoading,
        error,
    };
};

export default useDriver;
